<app-confetti></app-confetti>

@if (showWarningBanner) {
	<div class="main__warning-strip main__warning-strip--top"></div>
	<div class="main__warning-strip main__warning-strip--bottom"></div>
}

<!-- Add header for onboarding pages that use Website layout -->
<app-header-website *ngIf="showHeader" class="header u-display-block"></app-header-website>

<mine-snackbar class="snackbar"></mine-snackbar>

@if (isVerified && !showHeader && showSidenav) {
	<app-nav
		[showWarningBanner]="showWarningBanner"
		class="sidenav u-display-block" [role]="role">
	</app-nav>
}

<mineos-chatbot *ngIf="showMineChatbot()"></mineos-chatbot>

<google-copilot *ngIf="googleCopilotFF"></google-copilot>

<main class="main" 
	[ngClass]="{'main--padding': !showHeader && !disablePadding, 
				'main--onboarding-bg': showOnboardingBackground,
				'main--shrink': shrink && !disablePadding,
				'main--full-width-content': fullWidthMainContent,
				'main--version-history': showVersionHistory(),
				'main--shrink-full-width-content': fullWidthMainContent && shrink && !disablePadding
			 }">

	<router-outlet></router-outlet>

</main>